export const SET_VALUES = 'MAIN_PAGE_SET_VALUES';
export const SET_INITIAL_VALUES = 'MAIN_PAGE_SET_INITIAL_VALUES';

export const setValues = (values) => ({ type: SET_VALUES, values });
export const setInitialValues = () => ({ type: SET_INITIAL_VALUES });
